import { TeamService } from '@modules/team/team-service';
import { i18n } from '@shared/i18n';
import Errors from '@shared/error/errors';
import { get, update } from 'lodash';

export default {
  namespaced: true,
  
  state: {
    conferences: {},
    loading: false,
  },

  getters: {
    conferences: state => state.conferences,
    loading: state => state.loading,
  },

  mutations: {
    CONFERENCES_STARTED(state) {
      state.conferences = {};
      state.loading = true;
    },
    CONFERENCES_SUCCESS(state, { conferences }) {
      state.conferences = conferences;
      state.loading = false;
    },
    CONFERENCES_ERROR(state) {
      state.conferences = {};
      state.loading = false;
    },
  },

  actions: {
    async doLoad({commit}, { subpropertyId, subprogramId }) {
      try {
        commit('CONFERENCES_STARTED');
        
        const manageInput = {
          subpropertyId,
          type: 'subproperty'
        };
        
        const { orderBy, limit, offset } = [ null, 0, 0 ];
        const filter = { subprogram: subprogramId };
        
        const { rows } = await TeamService.listForNba( filter, orderBy, limit, offset, manageInput );

        const { conferences } = rows.map((item) => ({
            id: get(item, 'id', ''),
            name: get(item, 'name', ''),
            program: get(item, 'program', ''),
            subprogram: get(item, 'subprogram', ''),
            imageUrl: get(item, 'logo[0].thumbPublicUrl', ''),
            schoolName: get(item, 'school.name', ''),
            isMatched: get(item, 'school', null) !== null ,
            conference: get(item, 'groupsPhase.conference', ''),
            division: get(item, 'groupsPhase.division', ''),
            games: get(item, 'groupsPhase.games', ''),
            pointsFor: get(item, 'groupsPhase.pointsFor', ''),
            pointsAgainst: get(item, 'groupsPhase.pointsAgainst', ''),
            last4: get(item, 'groupsPhase.last4', '-'),
          })
        ).reduce((acumlator, current) => {
          const { conference, division } = current;          
          update(acumlator, `conferences.${conference.name}.title`, () =>  i18n(`entities.subprogram.nba.conference.${conference.name}.title`) );
          update(acumlator, `conferences.${conference.name}.divisions.${division.name}.title`, () =>  i18n(`entities.subprogram.nba.conference.${conference.name}.division.${division.name}`));
          update(acumlator, `conferences.${conference.name}.divisions.${division.name}.teams.${division.position}`, () => current);
          update(acumlator, `conferences.${conference.name}.teams.${conference.position}`, () => current);
          return acumlator;
        }, { conferences: {} });
        
        commit('CONFERENCES_SUCCESS', { conferences });
      } catch (error) {
        Errors.handle(error);
        commit('CONFERENCES_ERROR');
      }
    },
  }
};